/*=========================================================================================
  File Name: moduleFacility.js
  Description: Facility Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleFacilityState.js'
import mutations from './moduleFacilityMutations.js'
import actions from './moduleFacilityActions.js'
import getters from './moduleFacilityGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
